// API Configuration
export const API = process.env.NODE_ENV === 'production' 
  ? "https://api.winternorth.me"
  : "http://localhost:5000";

export default API;
